import React, { useState } from 'react';
import AddIcon from '@material-ui/icons/Add';
import CancelIcon from '@material-ui/icons/Cancel';
import EditIcon from '@material-ui/icons/Edit';
import NotInterestedIcon from '@material-ui/icons/NotInterested';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import IconButton from '@material-ui/core/IconButton';
import moment from 'moment';
import 'moment/locale/pt-br';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import Typography from '@material-ui/core/Typography';
import Collapse from '@material-ui/core/Collapse';
import Box from '@material-ui/core/Box';
import LinkIcon from '@material-ui/icons/Link';
import Link from '@material-ui/core/Link';
import environment from '../../environment';
import iuguService from '../../services/IUGU';
import { formatMoney } from '../../utils/common';
import { instanceAxios } from '../../InstanceAxios';

function RowsAssinaturas(props) {
  const [open, setOpen] = useState(false);
  const { assinatura, updateAlert, updateModal } = props;
  const dataInativacao =
    assinatura.status !== 'Ativa'
      ? moment(assinatura.updatedAt).format('L')
      : '*';
  const dataValidade = moment(assinatura.data_vencimento).format('L');

  const handleClickAtivar = async (idUsuario) => {
    updateAlert('Aguarde!', 'waning', true);
    await instanceAxios(localStorage.getItem('toobiauth'))
      .get(`${environment}/ativarAssinatura/${idUsuario}`)
      .then((res) => {
        updateAlert('Assinatura ativada com sucesso!', 'success', true);
        assinatura.status = 'Ativa';
      })
      .catch((err) => updateAlert('Erro ao ativar assinatura', 'error', true));
  };

  const handleClickSuspender = async (idUsuario) => {
    updateAlert('Aguarde!', 'waning', true);
    await instanceAxios(localStorage.getItem('toobiauth'))
      .get(`${environment}/suspenderAssinatura/${idUsuario}`)
      .then((res) => {
        updateAlert('Assinatura suspensa com sucesso!', 'success', true);
        assinatura.status = 'Suspensa';
      })
      .catch((err) =>
        updateAlert('Erro ao suspender assinatura', 'error', true)
      );
  };

  return (
    <>
      <TableRow key={assinatura.User.id}>
        <TableCell component="th" scope="row" align="center">
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row" align="center">
          {assinatura.User.nome}
        </TableCell>
        <TableCell component="th" scope="row" align="center">
          {assinatura.status}
        </TableCell>
        <TableCell component="th" scope="row" align="center">
          {moment(assinatura.createdAt).format('L')}
        </TableCell>
        <TableCell component="th" scope="row" align="center">
          {dataInativacao}
        </TableCell>
        <TableCell component="th" scope="row" align="center">
          {assinatura.PlanoAssinatura ? assinatura.PlanoAssinatura.nome : ''}
        </TableCell>
        <TableCell component="th" scope="row" align="center">
          {assinatura.PlanoAssinatura
            ? formatMoney(assinatura.PlanoAssinatura.valor / 100)
            : ''}
        </TableCell>
        <TableCell component="th" scope="row" align="center">
          {dataValidade}
        </TableCell>
        <TableCell component="th" scope="row" align="center">
          <IconButton
            aria-label="edit"
            size="small"
            onClick={() => updateModal(true, assinatura)}
          >
            <EditIcon />
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row" align="center">
          <Collapse in={assinatura.status !== 'Ativa'}>
            <IconButton
              color="primary"
              aria-label="ative"
              size="small"
              onClick={() => handleClickAtivar(assinatura.User.id)}
            >
              <AddIcon />
            </IconButton>
          </Collapse>
          <Collapse in={assinatura.status === 'Ativa'}>
            <IconButton
              color="secondary"
              aria-label="suspend"
              size="small"
              onClick={() => handleClickSuspender(assinatura.User.id)}
            >
              <CancelIcon />
            </IconButton>
          </Collapse>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell
          style={{ paddingBottom: 0, paddingTop: 0 }}
          colSpan={6}
          align="center"
        >
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Typography
                variant="h6"
                gutterBottom
                component="div"
                style={{ fontWeight: 'bold' }}
              >
                Pagamentos
              </Typography>
              <Table aria-label="pagamentos">
                <TableHead>
                  <TableRow>
                    <TableCell
                      style={{ minWidth: 140, fontWeight: 'bold' }}
                      align="center"
                    >
                      Dia Pagamento
                    </TableCell>
                    <TableCell
                      style={{ minWidth: 80, fontWeight: 'bold' }}
                      align="center"
                    >
                      Valor
                    </TableCell>
                    <TableCell
                      style={{ minWidth: 140, fontWeight: 'bold' }}
                      align="center"
                    >
                      Metodo De Pagamento
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {assinatura.PagamentoAssinaturas.map((pa) => (
                    <TableRow key={pa.id}>
                      <TableCell
                        component="th"
                        scope="row"
                        style={{ minWidth: 140 }}
                        align="center"
                      >
                        {moment(pa.createdAt).format('L')}
                      </TableCell>
                      <TableCell style={{ minWidth: 80 }} align="center">
                        {formatMoney(pa.valor / 100)}
                      </TableCell>
                      <TableCell style={{ minWidth: 140 }} align="center">
                        {iuguService.convertPayment(pa.metodo_pagamento)}
                      </TableCell>
                      <TableCell align="right">
                        <Link href={pa.url_fatura_pdf} target="_blank">
                          <LinkIcon />
                        </Link>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}

export default RowsAssinaturas;
